// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";

const validateRequiredDropdown = (value: string, fieldName: string) => {
    if (!value) {
        return siteMessage("Field_Required", fieldName).toString();
    }
};

export default validateRequiredDropdown;
